module.exports = __webpack_public_path__ + "img/mikeAwards3@2x.c03b45d9.jpg";